// Application version and build date
export const APP_VERSION = '1.0-rc-25';
export const BUILD_DATE = '2026-10-08';
